"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var localization_1 = require("../components/localization");
exports.default = {
    install: function (Vue) {
        Vue.prototype.$t = function (key, args) { return (0, localization_1.localize)(key, args); };
    }
};
